import React from "react";
import styled from "styled-components/macro";
import { HomeContent } from "../../../../hooks/api/queries/useHome";
import { breakpoint } from "../../../../styles/constants";
import { WImage } from "../../../ui/image/Image";
import { Link } from "react-router-dom";
import { appendCommitHash } from "../../../../utils/appendHash";
import { IMAGE_RATIOS } from "../../../../styles/imageRatios";

interface Props {
  item: HomeContent;
}

export const HomePromo = ({ item }: Props) => {
  const promo = item?.promos?.[0];

  if (!(promo?.localizedImage?.path || promo?.imageDefault?.path)) return null;

  return (
    <Wrapper>
      {promo?.destinationUrl || promo?.defaultDestinationUrl ? (
        <Link to={appendCommitHash(promo?.destinationUrl ?? "")}>
          <WImage image={promo?.localizedImage ?? promo.imageDefault} />
        </Link>
      ) : (
        <WImage image={promo?.localizedImage ?? promo.imageDefault} />
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-bottom: 60px;

  img {
    aspect-ratio: ${IMAGE_RATIOS.HOME_PROMO_MOBILE};
    object-fit: cover;
  }

  @media (min-width: ${breakpoint}) {
    margin-inline: auto;
    max-width: 740px;

    img {
      aspect-ratio: ${IMAGE_RATIOS.HOME_PROMO};
    }
  }
`;
